import { Icon } from '../Icon';

export function LightBanner({ banner }) {
    const p = banner.value;
    if (!p) return null;
    return (<div class="banner" role="status" aria-live="polite">
      <Icon name="lightbulb-off"/>
      <span class="banner-text"><b>{p.author}</b> {p.text}</span>
    </div>);
}

export function Toast({ queue }) {
    const t = queue.current.value;
    if (t === null) return null;
    return (<button type="button" class="toast" role="status" aria-live="polite" aria-label={`${t}. Tap to dismiss`} onClick={() => queue.dismiss()} onPointerDown={(e) => e.stopPropagation()}>{t}</button>);
}
